<div class="box-management">
  <div class="col-12">
    <div class="title-box" style="color: #16b097">
      <span class="material-icons" style="margin-right: 8px; font-size: 24px">
        insert_invitation
      </span>
      DADOS DO AGENDAMENTO
    </div>

    <div class="price-info" *ngIf="vehicle.leadPrice">
      <div class="label">
        VALOR OFERTADO
      </div>
      <div class="price">
        <span class="symbol">R$</span>{{vehicle.leadPrice | number}}
      </div>
      <div class="valid-date" *ngIf="vehicle.leadPriceExpirationDate">
        válido até {{vehicle.leadPriceExpirationDate | date: 'dd/MM/yyyy'}}
      </div>
    </div>

    <div class="info">
      <span class="material-icons">storefront</span>{{vehicle.evalDealerName}}
    </div>
    <div class="info">
      Visita agendada para {{vehicle.scheduledDate | date: 'dd/MM/yyyy'}}
    </div>

    <button (click)="sendToEvaluator()" *ngIf="vehicle.status === 'SCHEDULED'" class="mt-3 btn btn-block btn-primary btn-rounded">
      <div class="btn-spinner float-left" *ngIf="loading"></div>
      ENCAMINHAR PARA AVALIAÇÃO
    </button>
  </div>
</div>